<template>
  <div class="productos--alta__container">
    <h1>Alta de productos.</h1>
    <form @submit.prevent="agregarProducto()">


      <div v-if="tipoProducto" class="alta--producto">
        <div class="row--input">
          <label for="nombre">Nombre</label>
          <input type="text" id="nombre" name="nombre" placeholder="Producto" v-model="producto.nombre">
        </div>
        <div class="row--input">
          <label for="descripcion">Descripción</label>
          <input type="text" id="descripcion" name="descripcion" placeholder="Descripción del producto" v-model="producto.descripcion">
        </div>
        <div class="row--input">
          <label for="unidad">Unidad</label>
          <input type="text" id="unidad" name="unidad" placeholder="Unidad de la presentación" v-model="producto.unidad">
        </div>
        <div class="row--input">
          <label for="peso">Peso</label>
          <input type="number" id="peso" name="peso" placeholder="Peso de la presentación" v-model="producto.peso">
        </div>
        <div class="row--input">
          <label for="cantidad">Cantidad</label>
          <input type="number" id="cantidad" name="cantidad" placeholder="Cantidad de la presentación" v-model="producto.cantidad">
        </div>
        <div class="row--input">
          <label for="costo">Costo</label>
          <input type="number" id="costo" name="costo" placeholder="Costo del producto" v-model="producto.costo">
        </div>
        <button>Agregar producto</button>
      </div>


      <div v-if="!tipoProducto" class="alta--combo">
        <div class="row--input">
          <label for="nombre">Nombre del combo</label>
          <input type="text" id="nombre" name="nombre" placeholder="Nombre del combo" v-model="combo.nombre">
        </div>
      </div>


    </form>
  </div>
</template>

<script>
export default {
  name: 'ProductosAlta',
  props: [
    'id'
  ],
  data() {
    return {
      tipoProducto: true,
      //proveedor: '',
      producto: {
        nombre: '',
        descripcion: '',
        costo: '' ,

        unidad: '',
        peso: 0,
        cantidad: 1,
        //producto: '',
        proveedor: '',
        tipo: ['snack'],
        activo: true
      },
      combo: {
        nombre: '',
        productos: [],
        precio: '',
        valido: '',
        fechaVigenciaInicio: '2020/01/01',
        fechaVigenciaFin: '2020/12/31'
      }
    }
  },
  methods: {
    agregarProducto() {
      const self = this;
      const db = this.$firebase.firestore();
      const _body = {
        nombre: this.producto.nombre,
        descripcion: this.producto.descripcion,
        costo: parseInt(this.producto.costo, 10),
        unidad: this.producto.unidad,
        peso: parseInt(this.producto.peso, 10),
        cantidad: parseInt(this.producto.cantidad, 10),
        proveedor: this.id,
        tipo: ['snack'],
        activo: true
      };
      console.log(this.id + '-' + this.producto.nombre.replace(/\s/g, '-'));
      console.log(_body);
      db.collection("productos")
        .doc(this.id + '-' + this.producto.nombre.replace(/\s/g, '-'))
        .set(_body)
        .then( function() {
          
        })
        .catch( function () {
          
        });
    }
  }
}
</script>

<style lang="sass">
.productos--alta__container
  height: 100%
  padding: 0 20px
  h1
    font-size: 20px

.row--input
  width: 100%
  height: 40px
  display: flex
  text-align: left
  padding-bottom: 12px
  align-items: center
  label
    width: 180px
    justify-content: left
  input
    font-size: 18px
    height: 40px
    width: 250px
button
  height: 40px
  padding: 0 20px
  background: #02e079
  font-size: 18px
  color: white
  border: none
</style>
